const TIPOS_NEWS_BAR = [
  {
    // Novedad
    id: 1,
    backgroundColor: '#fdf6ec', 
    textColor: '#996414',
    tagBackgroundColor: '#e6a23c',
    tagTextColor: '#000000',
  },
  {
    // Aviso leve
    id: 2,
    backgroundColor: '#FBE8E0',
    textColor: '#AE4C13',
    tagBackgroundColor: '#C15415',
    tagTextColor: '#ffffff',
  },
  {
    // Aviso grave
    id: 3,
    backgroundColor: '#fef0f0',
    textColor: '#DF0000',
    tagBackgroundColor: '#DF0000',
    tagTextColor: '#ffffff',
  }
]

export {
  TIPOS_NEWS_BAR
}
